import React from 'react';
import Layout from 'components/styled/Layout/Layout';
import TopBar from 'components/Header/TopBar/TopBar';
import Header from 'components/Header/Header';
import InViewObserver from 'components/utility/InViewObserver/InViewObserver';
import {
  Header as HeaderWrapper,
  HeaderContainer,
  ContentWrapper,
  Title,
} from './shared/FAQ.styles';

const FAQHeader: React.FC = () => {
  return (
    <InViewObserver
      render={({ inview }: any): JSX.Element => (
        <Header inView={inview} withVerticalBackground>
          <TopBar
            entityTitle="Frequently Asked Questions"
            inView={inview}
            isSticky
            simpleTextTopBar
          />
          <Layout.MaxWidth>
            <HeaderContainer>
              <HeaderWrapper simpleTextTopBar>
                <ContentWrapper data-pw="header-faq-metadata">
                  <Title>Frequently Asked Questions</Title>
                </ContentWrapper>
              </HeaderWrapper>
            </HeaderContainer>
          </Layout.MaxWidth>
        </Header>
      )}
    />
  );
};

export default FAQHeader;
